export default (state = { open: false, user: {} }, action) =>
  action.type === "CLAIM_MODAL" ? action.payload : state
